
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/calendar/whatsapp",
      function () {
        return require("private-next-pages/integrations/calendar/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/calendar/whatsapp"])
      });
    }
  